module.exports = __webpack_public_path__ + "img/operate3.67d2939c.png";